module.exports = __webpack_public_path__ + "media/Tapping Next.e4ed43e7.mp3";